import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Container, Button, Image } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const sidebar = document.querySelector('.sidebar');
    if (sidebar) {
      sidebar.classList.toggle('active');
    }
  };

  // Get user initials for avatar
  const getUserInitials = () => {
    if (!currentUser || !currentUser.username) return '?';
    return currentUser.username
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <BootstrapNavbar className="navbar-main">
      <Container fluid className="px-2">
        <div className="d-flex align-items-center">
          <Button
            variant="link"
            className="d-lg-none menu-toggle-btn"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
          >
            <i className={`fas fa-${isSidebarOpen ? 'times' : 'bars'}`}></i>
          </Button>
          <BootstrapNavbar.Brand as={Link} to="/dashboard">
            <div className="d-flex align-items-center">
              <Image 
                src="/logo.jpg" 
                alt="Stremlite Logo" 
                width="32" 
                height="32" 
                className="d-inline-block align-top" 
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/32x32.png?text=S';
                  e.target.onError = null;
                }}
              />
              <span className="brand-text">Streamline</span>
            </div>
          </BootstrapNavbar.Brand>
        </div>
        
        {currentUser && (
          <div className="navbar-right">
            <div className="user-welcome d-none d-md-flex">
              <div className="user-avatar">
                {getUserInitials()}
              </div>
              <div className="user-info">
                <div className="user-name">
                  {currentUser.username}
                </div>
              </div>
            </div>
            <Button 
              variant="outline-light" 
              onClick={handleLogout} 
              className="logout-btn"
              title="Logout"
            >
              <i className="fas fa-sign-out-alt"></i>
              <span className="d-none d-sm-inline ms-1">Logout</span>
            </Button>
          </div>
        )}
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
